import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6d84d7ee&scoped=true&style=background-color%3A%20%23EAEAEA"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=6d84d7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d84d7ee",
  null
  
)

export default component.exports